import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import PatFumbleRecoveredByPositionPref from "./position-pref/pat-fumble-recovered-by-position-pref";

export default class PatRecovered extends Fragment {
    constructor(recoveredBy) {
        super();
        this.recoveredBy = recoveredBy;
        this.requiredData = [
            {
                name: "recoveredBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => false,
                displayName: "Recovered By",
                title: (team) => `Recovered By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true,
                positionPref: (play) =>
                    new PatFumbleRecoveredByPositionPref(play, this).resolve()
            }
        ];
    }

    getPlayers() {
        return [this.recoveredBy];
    }

    summarize(summaryContext, stringifier) {
        if (this.recoveredBy) {
            const message = `and recovered by ${stringifier.firstInitial(
                this.recoveredBy
            )}`;
            return new FragmentSummary(message);
        } else {
            return new FragmentSummary("");
        }
    }

    updateSummaryContext(summaryContext) {
        if (this.recoveredBy) {
            summaryContext.homeTeamHasPossession =
                this.recoveredBy.teamId === summaryContext.homeTeamId;
            summaryContext.playerInPossession = this.recoveredBy;
        }
    }

    toJSON() {
        return {
            ...super.toJSON(),
            recoveredBy: playerReducer(this.recoveredBy)
        };
    }
}
